import { useForm } from 'react-hook-form'
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { nextPage } from 'components/RCPro/helpers/nav'
import { isValidIBAN } from 'ibantools'
import api from 'helpers/api'
import Input from 'components/common/Input/Input'
import InputError from 'components/common/InputError/InputError'
import Arrow from 'components/assets/icons/Arrow'
import Button from 'components/common/Button/Button'
import { formParams } from 'constants/inputValidation'

const IbanForm = ({ state }) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { t } = useTranslation()
  const [ nextPageTransition ] = useOutletContext()
  const { transfer, layout: { next } } = state.texts

  // Initialize form
  const required = t('mainReporting:form.mandatory')
  const {
    register,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm({
    ...formParams,
    values: {
      owner: '',
      iban: ''
    },
  })

  // Submit form
  const onSubmit = handleSubmit(async data => {
    try{
      // const res = await api.post({
      //   url: '/adhesions/client',
      //   data: {},
      //   headers: { Authorization: `Bearer ${state.token}` },
      // })

      nextPage({ pathname, state, navigate })
      nextPageTransition()
    } catch (err) {
      console.log('Payment error')
    }
  })


  return (
    <>
      <h1>{transfer.title}</h1>

      <form onSubmit={onSubmit}>

        <Input
          error={errors.owner}
          register={register('owner', {
            required,
            validate: value => /[a-zA-ZÀ-ÿ-]{2,}/.test(value) || t('mainReporting:form.transfer.name.errors.pattern')
          })}
          label={t('mainReporting:form.transfer.name.label')}
          placeholder={t('mainReporting:form.transfer.name.placeholder')}
          disallowNumbers={true}
        />
        <InputError error={errors.owner} />


        <Input
          error={errors.iban}
          register={register('iban', {
            required,
            validate: value => isValidIBAN(value.replace(/\s/g,'')) || t('mainReporting:form.transfer.errors.pattern')
          })}
          label={t('mainReporting:form.transfer.iban.label')}
          placeholder={t('mainReporting:form.transfer.iban.placeholder')}
        />
        <InputError error={errors.iban} />


        <Button
          label={<>{next} <Arrow /></>}
          onClick={handleSubmit}
          type="primary"
          disabled={!isValid}
        />

      </form>
    </>
  )
}
export default IbanForm
